<template>
  <div style="width:100%;height:calc(100% - 20px);">
    <platformApplyList v-if="platformApplyAcdPageIndex===1" />
    <platformAdd v-if="platformApplyAcdPageIndex===2" />
  </div>
</template>

<script>
import '@/assets/scss/base/module/system.scss'
import platformApplyList from './platformApplyList'
import platformAdd from './platformAdd'
export default {
  name: 'detail',
  data() {
    return {}
  },
  props: [],
  components: {
    platformApplyList, platformAdd
  },
  computed: {
    platformApplyAcdPageIndex() {
      return this.$store.state.user.platformApplyAcdPageIndex
    }
  },
  mounted() { },
  methods: {},
  destroyed() {
    this.$store.commit('user/setPlatformApplyAcdPageIndex', { platformApplyAcdPageIndex: 1 })
  }
}
</script>
